import { DestroyRef, inject } from '@angular/core';

/**
 * Warnt vor dem Verwerfen ungespeicherter Änderungen beim Neuladen oder Schließen
 * des Tabs (NEX-1135).
 *
 * Der `CanDeactivate`-Guard deckt nur Navigation innerhalb der Anwendung ab. Ein
 * hartes Neuladen läuft am Router vorbei — dort war der Entwurfsstand bisher
 * stillschweigend weg. Aufgefallen ist das an einem im Testfall-Editor
 * übernommenen TCDL: „Übernehmen" schreibt in einer gepufferten Tabelle nur den
 * lokalen Entwurf, persistiert wird erst beim Speichern des Testfalls.
 *
 * `isDirty` wird bei jedem Versuch neu ausgewertet, nicht einmal beim Registrieren —
 * sonst würde die Warnung nach dem Speichern weiter erscheinen.
 *
 * Den Text des Dialogs bestimmt der Browser; eigene Meldungen ignorieren alle
 * gängigen Engines seit Jahren. Deshalb gibt es hier keinen i18n-Schlüssel.
 *
 * Es werden bewusst beide Wege gesetzt: `preventDefault()` ist der aktuelle
 * Standard, `returnValue` der ältere — Safari wertet nur den zweiten aus, und
 * Safari liegt in der Angular-Default-Browserliste dieses Projekts. Mit nur
 * einem der beiden bliebe die Warnung auf einem Teil der Zielbrowser aus.
 */
export function warnBeforeUnload(isDirty: () => boolean): void {
  const handler = (event: BeforeUnloadEvent): void => {
    if (!isDirty()) {
      return;
    }
    event.preventDefault();
    event.returnValue = '';
  };
  window.addEventListener('beforeunload', handler);
  inject(DestroyRef).onDestroy(() => window.removeEventListener('beforeunload', handler));
}
